import styled from 'styled-components';

export const Wrap = styled.div`
    position: absolute;
    left: 83%;
    top: 108%;
    transform: translate(-50%, -50%);
`;

export const HeartBox = styled.img`
    width: 47px;
    height: 47px;

    transform: translate(0, -50%);
    position: absolute;
    left: 50%;
    top: 50%;
    image-rendering: pixelated;
`;
